import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=1b8f54cb&scoped=true"
import script from "./ListaClientes.vue?vue&type=script&lang=js"
export * from "./ListaClientes.vue?vue&type=script&lang=js"
import style0 from "./ListaClientes.vue?vue&type=style&index=0&id=1b8f54cb&prod&scoped=true&lang=css"
import style1 from "./ListaClientes.vue?vue&type=style&index=1&id=1b8f54cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f54cb",
  null
  
)

export default component.exports